import React, { useState, useRef } from 'react';
import Header from './HeaderLayouts';
import Footer from './FooterLayouts';
import { FiPhone, FiMail, FiMapPin, FiClock, FiUpload, FiCheckCircle, FiX } from 'react-icons/fi';
import Paytm from "../assets/paytmimg.png";
import QR_code1 from "../assets/QR_code1.png";
import Bank from "../assets/Banklogo.png"
import QR_code2 from "../assets/QR_code2.png"
import Gpaylogo from "../assets/Gpaylogo.png"
import pro_bg from "../assets/productbanner.jpg"; // Import your product banner
import API_BASE_URL from "./apiConfig";
import axios from 'axios';

function PaymentInfo() {
  const [hoverCard, setHoverCard] = useState(null);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [orderId, setOrderId] = useState('');
  const [transactionId, setTransactionId] = useState('');
  const [uploadError, setUploadError] = useState('');
  const fileInputRef = useRef(null);

  // Handle payment card click
  const handlePaymentClick = (method) => {
    setSelectedPaymentMethod(method);
    setShowUploadModal(true);
    setSelectedFile(null);
    setPreviewUrl(null);
    setUploadSuccess(false);
    setUploadError('');
  };

  // Handle file selection
  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      const validTypes = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];
      if (!validTypes.includes(file.type)) {
        setUploadError('Please upload only JPG, PNG, or PDF files');
        return;
      }

      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        setUploadError('File size should be less than 5MB');
        return;
      }

      setSelectedFile(file);
      setUploadError('');

      // Create preview URL for images
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewUrl(reader.result);
        };
        reader.readAsDataURL(file);
      } else {
        setPreviewUrl(null);
      }
    }
  };

  // Handle file upload
  const handleUpload = async () => {
    if (!selectedFile) {
      setUploadError('Please select a file to upload');
      return;
    }

    if (!orderId) {
      setUploadError('Please enter your Order ID');
      return;
    }

    setUploading(true);
    setUploadError('');

    const formData = new FormData();
    formData.append('OrderId', orderId);
    formData.append('TransactionId', transactionId || '');
    formData.append('CompanyId', '3'); // Add CompanyId as required by API
    formData.append('attachment', selectedFile);

    try {
      const response = await axios.post(
        `${API_BASE_URL}api/Crackers/AddPaymentAttachment`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.data.statusCode === 200) {
        setUploadSuccess(true);
        alert('✅ Payment attachment uploaded successfully! We will verify your payment and update your order status.');
        setTimeout(() => {
          setShowUploadModal(false);
          setUploadSuccess(false);
          setSelectedFile(null);
          setPreviewUrl(null);
          setOrderId('');
          setTransactionId('');
        }, 2000);
      } else {
        setUploadError(response.data.statusDesc || 'Upload failed. Please try again.');
      }
    } catch (error) {
      console.error('Upload error:', error);
      const errorMsg = error.response?.data?.statusDesc || 
                       error.response?.data?.message || 
                       'Network error. Please try again.';
      setUploadError(errorMsg);
      alert(`❌ Upload failed: ${errorMsg}`);
    } finally {
      setUploading(false);
    }
  };

  // Get payment method display name
  const getPaymentMethodName = (method) => {
    switch(method) {
      case 'bank-enterprises': return 'Bank Transfer - HARI BALAJI ENTERPRISES';
      case 'gpay': return 'Google Pay';
      case 'bank-agencies': return 'Bank Transfer - HARI BALAJI AGENCIES';
      default: return method;
    }
  };

  return (
    <>
      <Header />

      {/* Hero Section */}
      <div style={heroSectionStyle}>
        <div style={heroOverlayStyle}></div>
        <div style={heroContentStyle}>
          <h1 style={heroTitleStyle}>Secure Payment Options</h1>
          <p style={heroTextStyle}>Choose your preferred method to complete your fireworks order</p>
        </div>
      </div>

      {/* Payment Options Section */}
      <section style={paymentSectionStyle}>
        {/* Upload Notice */}
        <div style={noticeBoxStyle}>
          <FiUpload style={{ marginRight: '10px', color: '#FF6B35', fontSize: '1.2rem' }} />
          <span>
            <strong>Important:</strong> After making payment, please click on your payment method to upload the transaction screenshot for verification.
          </span>
        </div>

        <div style={paymentContainerStyle}>
          {/* Bank Transfer - Hari Balaji Enterprises (Card 1) */}
          <div
            style={{
              ...paymentCardStyle,
              backgroundColor: hoverCard === "bank-enterprises" ? '#e8d7e7ff' : '#f1e9f1ff',
              borderColor: hoverCard === "bank-enterprises" ? '#cbafcaff' : '#ddaadbff',
              transform: hoverCard === "bank-enterprises" ? 'translateY(-5px)' : 'translateY(0)',
              boxShadow: hoverCard === "bank-enterprises" ? '0px 12px 25px rgba(107, 63, 105, 0.7)' : '0px 8px 18px rgba(107, 63, 105, 0.5)',
              zIndex: hoverCard === "bank-enterprises" ? 10 : 1,
              cursor: 'pointer'
            }}
            onMouseEnter={() => setHoverCard("bank-enterprises")}
            onMouseLeave={() => setHoverCard(null)}
            onClick={() => handlePaymentClick('bank-enterprises')}
          >
            {/* Always show bank icon and name */}
            <div style={paymentIconContainerStyle}>
              <img 
                src={Bank} 
                alt="Bank"
                style={paymentIconStyle}
              />
            </div>
            <p style={paymentLabelStyle}>Bank Transfer</p>
            <p style={companySubNameStyle}>HARI BALAJI ENTERPRISES</p>
            
            {/* Always show upload instruction */}
            <p style={defaultInstructionStyle}>Click to upload payment screenshot</p>

            {/* Show Bank details on hover */}
            {hoverCard === "bank-enterprises" && (
              <div style={bankDetailsPopupStyle}>
                <div style={bankDetailsContentStyle}>
                  <strong style={bankNameStyle}>HARI BALAJI ENTERPRISES</strong>
                  <p style={bankDetailStyle}>A/c No: 521150050800179</p>
                  <p style={bankDetailStyle}>IFSC Code: TMBL0000521</p>
                  <p style={bankDetailStyle}>Branch: MEENAMPATTI</p>
                  <p style={bankDetailStyle}>Place: SIVAKASI</p>
                </div>
              </div>
            )}
          </div>

          {/* GPay (Card 2) */}
          <div
            style={{
              ...paymentCardStyle,
              backgroundColor: hoverCard === "gpay" ? '#e8d7e7ff' : '#f1e9f1ff',
              borderColor: hoverCard === "gpay" ? '#cbafcaff' : '#ddaadbff',
              transform: hoverCard === "gpay" ? 'translateY(-5px)' : 'translateY(0)',
              boxShadow: hoverCard === "gpay" ? '0px 12px 25px rgba(107, 63, 105, 0.7)' : '0px 8px 18px rgba(107, 63, 105, 0.5)',
              zIndex: hoverCard === "gpay" ? 10 : 1,
              cursor: 'pointer'
            }}
            onMouseEnter={() => setHoverCard("gpay")}
            onMouseLeave={() => setHoverCard(null)}
            onClick={() => handlePaymentClick('gpay')}
          >
            {/* Always show GPay logo */}
            <div style={gpayLogoContainerStyle}>
              <img 
                src={Gpaylogo} 
                alt="GPay"
                style={gpayLogoStyle}
              />
              <p style={paymentLabelStyle}>Google Pay</p>
              
              {/* Always show upload instruction */}
              <p style={defaultInstructionStyle}>Click to upload payment screenshot</p>
            </div>

            {/* Show GPay numbers on hover */}
            {hoverCard === "gpay" && (
              <div style={gpayNumberPopupStyle}>
                <strong style={gpayNumberLabelStyle}>GPay Numbers</strong>
                <p style={gpayNumberStyle}>+91 9751043474</p>
                <p style={gpayOrStyle}> (or) </p>
                <p style={gpayNumberStyle}>+91 9843655396</p>
              </div>
            )}
          </div>

          {/* Bank Transfer - Hari Balaji Agencies (Card 3) */}
          <div
            style={{
              ...paymentCardStyle,
              backgroundColor: hoverCard === "bank-agencies" ? '#e8d7e7ff' : '#f1e9f1ff',
              borderColor: hoverCard === "bank-agencies" ? '#cbafcaff' : '#ddaadbff',
              transform: hoverCard === "bank-agencies" ? 'translateY(-5px)' : 'translateY(0)',
              boxShadow: hoverCard === "bank-agencies" ? '0px 12px 25px rgba(107, 63, 105, 0.7)' : '0px 8px 18px rgba(107, 63, 105, 0.5)',
              zIndex: hoverCard === "bank-agencies" ? 10 : 1,
              cursor: 'pointer'
            }}
            onMouseEnter={() => setHoverCard("bank-agencies")}
            onMouseLeave={() => setHoverCard(null)}
            onClick={() => handlePaymentClick('bank-agencies')}
          >
            {/* Always show bank icon and name */}
            <div style={paymentIconContainerStyle}>
              <img 
                src={Bank} 
                alt="Bank"
                style={paymentIconStyle}
              />
            </div>
            <p style={paymentLabelStyle}>Bank Transfer</p>
            <p style={companySubNameStyle}>HARI BALAJI AGENCIES</p>
            
            {/* Always show upload instruction */}
            <p style={defaultInstructionStyle}>Click to upload payment screenshot</p>

            {/* Show Bank details on hover */}
            {hoverCard === "bank-agencies" && (
              <div style={bankDetailsPopupStyle}>
                <div style={bankDetailsContentStyle}>
                  <strong style={bankNameStyle}>HARI BALAJI AGENCIES</strong>
                  <p style={bankDetailStyle}>A/c No: 52153666666666</p>
                  <p style={bankDetailStyle}>IFSC Code: TMBL0000521</p>
                  <p style={bankDetailStyle}>Branch: MEENAMPATTI</p>
                  <p style={bankDetailStyle}>Place: SIVAKASI</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Upload Modal */}
      {showUploadModal && (
        <div style={modalOverlayStyle} onClick={() => !uploading && setShowUploadModal(false)}>
          <div style={modalContainerStyle} onClick={(e) => e.stopPropagation()}>
            <div style={modalHeaderStyle}>
              <h3 style={modalTitleStyle}>
                Upload Payment Proof
              </h3>
              <button 
                style={modalCloseButtonStyle}
                onClick={() => !uploading && setShowUploadModal(false)}
                disabled={uploading}
              >
                ×
              </button>
            </div>

            <div style={modalBodyStyle}>
              {uploadSuccess ? (
                <div style={successMessageStyle}>
                  <FiCheckCircle style={{ fontSize: '3rem', color: '#10B981', marginBottom: '1rem' }} />
                  <h4 style={{ margin: '0 0 0.5rem', color: '#10B981' }}>Upload Successful!</h4>
                  <p>Your payment screenshot has been uploaded successfully.</p>
                </div>
              ) : (
                <>
                  <div style={paymentMethodBadgeStyle}>
                    Payment Method: <strong>{getPaymentMethodName(selectedPaymentMethod)}</strong>
                  </div>

                  <div style={formGroupStyle}>
                    <label style={formLabelStyle}>Order ID *</label>
                    <input
                      type="text"
                      value={orderId}
                      onChange={(e) => setOrderId(e.target.value)}
                      placeholder="Enter your Order ID"
                      style={formInputStyle}
                      disabled={uploading}
                    />
                  </div>

                  <div style={formGroupStyle}>
                    <label style={formLabelStyle}>Transaction ID / UTR (Optional)</label>
                    <input
                      type="text"
                      value={transactionId}
                      onChange={(e) => setTransactionId(e.target.value)}
                      placeholder="Enter transaction ID if available"
                      style={formInputStyle}
                      disabled={uploading}
                    />
                  </div>

                  <div style={formGroupStyle}>
                    <label style={formLabelStyle}>Upload Screenshot *</label>
                    <div 
                      style={uploadAreaStyle}
                      onClick={() => !uploading && fileInputRef.current?.click()}
                    >
                      {previewUrl ? (
                        <img 
                          src={previewUrl} 
                          alt="Preview" 
                          style={previewImageStyle}
                        />
                      ) : selectedFile ? (
                        <div style={fileNameStyle}>
                          <FiCheckCircle style={{ color: '#10B981', marginRight: '0.5rem' }} />
                          {selectedFile.name}
                        </div>
                      ) : (
                        <>
                          <FiUpload style={{ fontSize: '2rem', color: '#9CA3AF', marginBottom: '0.5rem' }} />
                          <p style={{ margin: 0, color: '#6B7280' }}>
                            Click to upload or drag and drop
                          </p>
                          <p style={{ margin: '0.25rem 0 0', fontSize: '0.8rem', color: '#9CA3AF' }}>
                            JPG, PNG, PDF (Max 5MB)
                          </p>
                        </>
                      )}
                      <input
                        ref={fileInputRef}
                        type="file"
                        accept=".jpg,.jpeg,.png,.pdf"
                        onChange={handleFileSelect}
                        style={{ display: 'none' }}
                        disabled={uploading}
                      />
                    </div>
                  </div>

                  {uploadError && (
                    <div style={errorMessageStyle}>
                      <FiX style={{ marginRight: '0.5rem' }} />
                      {uploadError}
                    </div>
                  )}
                </>
              )}
            </div>

            {/* Footer */}
            {!uploadSuccess && (
              <div style={modalFooterStyle}>
                <button
                  style={cancelButtonStyle}
                  onClick={() => setShowUploadModal(false)}
                  disabled={uploading}
                >
                  Cancel
                </button>
                <button
                  style={uploadButtonStyle}
                  onClick={handleUpload}
                  disabled={uploading || !selectedFile || !orderId}
                >
                  {uploading ? (
                    <>
                      <span style={{ marginRight: '8px' }}>
                        <svg width="16" height="16" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
                          <g fill="none" fillRule="evenodd">
                            <g transform="translate(1 1)" strokeWidth="2">
                              <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
                              <path d="M36 18c0-9.94-8.06-18-18-18">
                                <animateTransform
                                  attributeName="transform"
                                  type="rotate"
                                  from="0 18 18"
                                  to="360 18 18"
                                  dur="1s"
                                  repeatCount="indefinite"
                                />
                              </path>
                            </g>
                          </g>
                        </svg>
                      </span>
                      UPLOADING...
                    </>
                  ) : (
                    'UPLOAD SCREENSHOT'
                  )}
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}

// ===== STYLES =====

const heroSectionStyle = {
  position: 'relative',
  height: '200px',
  backgroundImage: `url(${pro_bg})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  color: 'white',
  overflow: 'hidden',
};

const heroOverlayStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0,0,0,0.4)',
};

const heroContentStyle = {
  position: 'relative',
  zIndex: 1,
  maxWidth: '700px',
  padding: '0 20px',
};

const heroTitleStyle = {
  fontSize: '2rem',
  fontWeight: '700',
  marginBottom: '0.5rem',
  textShadow: '0 2px 4px rgba(0,0,0,0.3)',
};

const heroTextStyle = {
  fontSize: '1rem',
  lineHeight: '1.6',
  textShadow: '0 1px 2px rgba(0,0,0,0.3)',
};

const paymentSectionStyle = {
  padding: '2rem 1.5rem',
  backgroundColor: '#f9fafc',
};

const paymentContainerStyle = {
  maxWidth: '1200px',
  margin: '0 auto',
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
  gap: '2rem',
  position: 'relative',
  justifyContent: 'center',
};

const paymentCardStyle = {
  borderRadius: '12px',
  padding: '1rem',
  display: 'flex',
  flexDirection: 'column',
  transition: 'all 0.3s ease',
  overflow: 'hidden',
  position: 'relative',
  backgroundColor: '#f1e9f1ff',
  border: '1px solid #ddaadbff',
  boxShadow: '0px 8px 18px rgba(107, 63, 105, 0.5)',
  minHeight: '280px',
  maxHeight: '280px',
  height: '280px',
  textAlign: 'center',
  cursor: 'pointer',
  alignItems: 'center',
  justifyContent: 'center',
};

const paymentIconContainerStyle = {
  marginBottom: '0.5rem',
  transition: 'transform 0.3s ease',
};

const paymentIconStyle = {
  width: '50px',
  height: 'auto',
  transition: 'transform 0.3s ease',
};

const paymentLabelStyle = {
  fontSize: '1rem',
  fontWeight: '600',
  color: '#474547ff',
  margin: '0.2rem 0',
};

const companySubNameStyle = {
  fontSize: '0.85rem',
  fontWeight: '500',
  color: '#5e045bff',
  margin: '0.2rem 0',
  fontStyle: 'italic',
};

// Default instruction style (always visible)
const defaultInstructionStyle = {
  fontSize: '0.8rem',
  color: '#827a77ff',
  margin: '0.5rem 0 0 0',
  fontWeight: '500',
  backgroundColor: 'rgba(123, 115, 112, 0.1)',
  padding: '0.25rem 0.5rem',
  borderRadius: '4px',
  display: 'inline-block',
};

// Bank Details Styles (appears on hover)
const bankDetailsPopupStyle = {
  position: "absolute",
  top: "0",
  left: "0",
  right: "0",
  bottom: "0",
  backgroundColor: "#f1e9f1ff",
  borderRadius: "10px",
  padding: "10px",
  zIndex: 10,
  fontSize: "0.9rem",
  lineHeight: "1.4",
  border: "1px solid #ddaadbff",
  color: "#474547ff",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  opacity: "0.98",
  overflowY: "auto",
  animation: 'fadeIn 0.3s ease',
};

const bankDetailsContentStyle = {
  width: '100%',
  maxHeight: '100%',
};

const bankNameStyle = {
  fontSize: '0.95rem',
  display: 'block',
  marginBottom: '4px',
  color: '#5e045bff',
};

const bankDetailStyle = {
  margin: '2px 0',
  fontSize: '0.85rem',
};

// GPay Number Popup Styles (appears on hover)
const gpayNumberPopupStyle = {
  position: "absolute",
  top: "0",
  left: "0",
  right: "0",
  bottom: "0",
  backgroundColor: "#f1e9f1ff",
  borderRadius: "10px",
  padding: "15px",
  zIndex: 10,
  fontSize: "0.9rem",
  lineHeight: "1.5",
  border: "1px solid #ddaadbff",
  color: "#474547ff",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  opacity: "0.98",
  animation: 'fadeIn 0.3s ease',
};

const gpayNumberLabelStyle = {
  fontSize: '1.2rem',
  fontWeight: '700',
  color: '#5e045bff',
  marginBottom: '0.5rem',
};

const gpayNumberStyle = {
  fontSize: '1.1rem',
  fontWeight: '600',
  color: '#474547ff',
  margin: '0.2rem 0',
  letterSpacing: '1px',
};

const gpayOrStyle = {
  fontSize: '0.9rem',
  color: '#666',
  margin: '0.1rem 0',
};

const gpayLogoContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  width: '100%',
};

const gpayLogoStyle = {
  width: '120px',
  height: 'auto',
  marginBottom: '0.5rem',
  objectFit: 'contain',
};

const noticeBoxStyle = {
  maxWidth: '800px',
  margin: '0 auto 2rem',
  padding: '1rem 1.5rem',
  backgroundColor: '#fff8e1',
  borderLeft: '4px solid #FF6B35',
  borderRadius: '0 8px 8px 0',
  display: 'flex',
  alignItems: 'flex-start',
  fontSize: '0.9rem',
  color: '#555',
};

// Modal Styles
const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
  padding: '1rem',
};

const modalContainerStyle = {
  backgroundColor: 'white',
  borderRadius: '12px',
  maxWidth: '500px',
  width: '100%',
  maxHeight: '90vh',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
};

const modalHeaderStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '1rem 1.5rem',
  borderBottom: '1px solid #e2e8f0',
  backgroundColor: '#f8fafc',
};

const modalTitleStyle = {
  margin: 0,
  fontSize: '1.2rem',
  color: '#1e293b',
  fontWeight: 600,
};

const modalCloseButtonStyle = {
  background: 'none',
  border: 'none',
  fontSize: '1.5rem',
  cursor: 'pointer',
  color: '#64748b',
  padding: '0.25rem 0.5rem',
  borderRadius: '0.25rem',
  transition: 'all 0.2s',
};

const modalBodyStyle = {
  padding: '1.5rem',
  overflowY: 'auto',
  flex: '1 1 auto',
  maxHeight: 'calc(90vh - 140px)',
};

const paymentMethodBadgeStyle = {
  backgroundColor: '#f1e9f1ff',
  padding: '0.75rem',
  borderRadius: '0.375rem',
  marginBottom: '1.5rem',
  textAlign: 'center',
  color: '#5e045bff',
  border: '1px solid #ddaadbff',
};

const formGroupStyle = {
  marginBottom: '1.25rem',
};

const formLabelStyle = {
  display: 'block',
  marginBottom: '0.5rem',
  fontWeight: 600,
  fontSize: '0.9rem',
  color: '#1e293b',
};

const formInputStyle = {
  width: '100%',
  padding: '0.75rem',
  border: '1px solid #cbd5e1',
  borderRadius: '0.375rem',
  fontSize: '0.9rem',
  transition: 'border-color 0.2s',
  boxSizing: 'border-box',
};

const uploadAreaStyle = {
  border: '2px dashed #cbd5e1',
  borderRadius: '0.5rem',
  padding: '1.5rem',
  textAlign: 'center',
  cursor: 'pointer',
  transition: 'all 0.2s',
  backgroundColor: '#f8fafc',
  minHeight: '120px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
};

const previewImageStyle = {
  maxWidth: '100%',
  maxHeight: '150px',
  objectFit: 'contain',
  borderRadius: '0.375rem',
};

const fileNameStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#1e293b',
  fontSize: '0.9rem',
  wordBreak: 'break-all',
};

const errorMessageStyle = {
  backgroundColor: '#fee2e2',
  color: '#dc2626',
  padding: '0.75rem',
  borderRadius: '0.375rem',
  fontSize: '0.85rem',
  display: 'flex',
  alignItems: 'center',
  marginBottom: '1rem',
};

const modalFooterStyle = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '0.75rem',
  padding: '1rem 1.5rem',
  borderTop: '1px solid #e2e8f0',
  backgroundColor: '#f8fafc',
  flexShrink: 0,
};

const cancelButtonStyle = {
  padding: '0.6rem 1.2rem',
  border: '1px solid #cbd5e1',
  backgroundColor: 'white',
  color: '#1e293b',
  borderRadius: '0.375rem',
  fontWeight: 600,
  fontSize: '0.9rem',
  cursor: 'pointer',
  transition: 'all 0.2s',
};

const uploadButtonStyle = {
  padding: '0.6rem 1.2rem',
  backgroundColor: '#5e045bff',
  color: 'white',
  border: 'none',
  borderRadius: '0.375rem',
  fontWeight: 600,
  fontSize: '0.9rem',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '160px',
  transition: 'all 0.2s',
};

const successMessageStyle = {
  textAlign: 'center',
  padding: '2rem',
};

// Add keyframes animation for fadeIn
const style = document.createElement('style');
style.textContent = `
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 0.98; }
  }
`;
document.head.appendChild(style);

export default PaymentInfo;